import L from "leaflet";
import "proj4leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "./LeafletMap.css";
import {
    useCoordinatesMapControl,
    useScaleMapControl,
    useResetViewMapControl,
    useSetMarkerMapControl,
    useBaseLayerAutoControl,
} from "./controls";
import {useMapContext} from "../MapProvider";

import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

L.Icon.Default.imagePath = "";
L.Icon.Default.mergeOptions({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    shadowUrl: markerShadow,
});

export const mapOverlayPanes = [...Array(10).keys()].map(i => "overlayPane" + i);

export function useLeafletMap() {
    const {mapDOMRef, mapObjectRef, mapCRS, mapOptions, controlOptions} =
        useMapContext();

    const {addCoordinatesMapControl} = useCoordinatesMapControl();
    const {addScaleMapControl} = useScaleMapControl();
    const {addResetViewMapControl} = useResetViewMapControl(
        mapOptions.center,
        mapOptions.zoom
    );
    const {addSetMarkerMapControl} = useSetMarkerMapControl();
    const {addBaseLayerZoomControl} = useBaseLayerAutoControl();

    if (mapCRS) {
        mapOptions["crs"] = new L.Proj.CRS(mapCRS.code, mapCRS.proj4, {
            ...mapCRS.options,
        });
    }

    const createMap = () => {
        console.log("CARTO >> Creating map", {mapOptions});
        const map = L.map(mapDOMRef.current, {
            zoomSnap: 0, // http://leafletjs.com/reference.html#map-zoomsnap
            zoomControl: false,
            ...mapOptions,
        });

        L.control
            .zoom({
                position: "topright",
            })
            .addTo(map);

        console.log("CARTO >> Setting map options", {controlOptions});
        if (controlOptions.coordinates?.show) {
            addCoordinatesMapControl(map);
        }
        if (controlOptions.scale?.show) {
            addScaleMapControl(map);
        }
        if (controlOptions.resetview?.show) {
            addResetViewMapControl(map);
        }
        if (controlOptions.setmarker.show) {
            addSetMarkerMapControl(map);
        }
        if (controlOptions.baselayer.show) {
            addBaseLayerZoomControl(map);
        }

        // Add a series of custom panes for overlay layers
        mapOverlayPanes.forEach((p, i) => {
            map.createPane(p);
            map.getPane(p).style.zIndex = (400 + (i + 1) * 5).toString();
        });

        mapObjectRef.current = map;

        return map;
    };

    const zoomToBbox = bbox => {
        // bbox: [oeste, sur, este, norte]
        console.log("CARTO >> Zooming to bbox", {bbox});
        const bounds = L.latLngBounds([bbox[1], bbox[0]], [bbox[3], bbox[2]]);
        mapObjectRef.current.fitBounds(bounds, {padding: [20, 20]});
    };

    const zoomToPoint = center => {
        console.log("zoomToPoint", {center});
        mapObjectRef.current.flyTo(center, 16, {
            duration: 2,
        });
    };

    const isMapLoaded = () => mapObjectRef.current._loaded;

    const removeMap = () => {
        console.log("CARTO >> Removing map");
        mapObjectRef.current.remove();
    };

    return {createMap, isMapLoaded, removeMap, zoomToBbox, zoomToPoint};
}
